import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
  color: #4f4f4f;
  cursor: help;
`
